import { AppHelper } from "../appHelper.js";
import { DashboardEntity } from "../dashboard/config/dashboardConfig.js";
import { AppBaseProps, CommonApp, Metadata } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { Config } from "../core/config/config.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import React from "react"

export const open = () => {
    return new Promise<boolean>(async (resolve) => {
        const { AdditionalData } = await HTTPService.get<JsonResultClass>("Dashboard/GetStatisticsForEditing");
        const metaData: Metadata = {
            tabs: [
                {
                    title: Helper.getTranslation("WebSMS.UserSettings.Dashboard.MyDashboard"),
                    moduleName: "app/dashboard/config/dashboardConfig",
                    iconName: "chart-column",
                    visible: true,
                    type: "tab_with_module",
                    props: {
                        custom: true
                    }
                } as any
            ],
            additional: {
                objects: []
            },
            pageTitle: Helper.getTranslation("WebSMS.UserSettings.Dashboard.MyDashboard"),
            hideMenu: false,
            menuDataSource: [
                {
                    type: "save"
                }
            ],
            rightDrawerContainer: {
                visible: true,
                width: 400,
                multipleComponents: [
                    {
                        iconName: "question-circle",
                        iskey: "RIGHTDRAWER_COMPONENT_IFRAME",
                        moduleName: "app/core/components/iframe",
                        props: {
                            url: '{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/grundlagen/dashboard'
                        },
                        renderAlways: true,
                        type: "rightdrawer_help",
                    }
                ]
            }
        };
        const entity: DashboardEntity = {
            IndividualFields: {},
            IsNew: false,
            IsWatchable: false,
            CustomDashboardStatistics: AdditionalData["CustomDashboardStatistics"],
            DashboardStatistics: AdditionalData["DashboardStatistics"],
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            User: {
                Name: Config.user.userName
            }
        };
        var isSaved = false;

        const props: EditDashboardProps = {
            context: {},
            dataSources: {},
            entity: entity,
            isWindow: true,
            metadata: metaData,
            title: Helper.getTranslation("WebSMS.UserSettings.Dashboard.MyDashboard"),
            onSave: () => {
                isSaved = true;
            }
        };
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(EditDashboard, props);
        });
        sheet.bind(SheetEventType.Close, () => {
            resolve(isSaved)
        })
    })
}

interface EditDashboardProps extends AppBaseProps {
    entity: DashboardEntity;
    onSave: () => void;
}

class EditDashboard extends React.Component<EditDashboardProps, any>{
    common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    save = async () => {
        const result = await HTTPService.post<JsonResultClass>("Dashboard/SaveCustom", {
            dashboardStatistics: this.props.entity.CustomDashboardStatistics
        });
        if (result.Code == 0) {
            this.props.onSave();
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            this.common.handlePostSave(result.Code === 0, false);
            this.setState({});
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            default:
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props}/>;
    }
}